module.exports = __webpack_public_path__ + "static/media/05.ea71d2a4.jpg";